import React from "react";
import {
  Button,
  Checkbox,
  CheckboxGroup,
  Flex,
  HStack,
  Text,
} from "@chakra-ui/react";
const FILTER_STYLE = {
  ".chakra-checkbox__control": {
    borderColor: "gray.600",
    borderRadius: "50%",
    width: "18px",
    height: "18px",
    _checked: {
      bg: "gray.700",
      borderColor: "gray.400",
    },
    _hover: {
      borderColor: "gray.500",
    },
  },
};

const FILTER_TRANSLATIONS = {
  post: "dashboard.posts",
  conference: "dashboard.conferences",
  video: "dashboard.videos",
  news: "dashboard.news",
  publication: "dashboard.publications",
  notice: "dashboard.notices",
};
const FILTERS = Object.keys(FILTER_TRANSLATIONS);

export const FeedFilters = ({
  selectedTypes,
  onChange,
  onToggleAll,
  t,
  actionButton = null,
}) => (
  <Flex align="center" mb={2} wrap="wrap" gap={2} justify="space-between">
    <CheckboxGroup value={selectedTypes} onChange={onChange}>
      <Flex align="center" wrap="wrap" gap={2}>
        <HStack spacing={2} wrap="wrap">
          {FILTERS.map((filter) => (
            <Checkbox
              key={filter}
              value={filter}
              size="sm"
              iconColor="white"
              colorScheme="gray"
              sx={{
                ...FILTER_STYLE,
                ".chakra-checkbox__control": {
                  ...FILTER_STYLE[".chakra-checkbox__control"],
                  width: filter === "post" ? "15px" : "18px",
                  height: filter === "post" ? "15px" : "18px",
                },
              }}
            >
              <HStack spacing={1} color="gray.400" _hover={{ color: "gray.600" }}>
                <Text fontSize="xs">{t(FILTER_TRANSLATIONS[filter])}</Text>
              </HStack>
            </Checkbox>
          ))}
        </HStack>
        {/* onToggleAll flips between every filter and none. */}
        <Button
          variant="link"
          size="xs"
          fontWeight="normal"
          color="gray.400"
          _hover={{ color: "gray.600" }}
          onClick={onToggleAll}
        >
          {selectedTypes.length > 0
            ? t("dashboard.filters_clear_all")
            : t("dashboard.filters_select_all")}
        </Button>
      </Flex>
    </CheckboxGroup>
    {actionButton}
  </Flex>
);
